// @ts-nocheck
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';

import DialogTransition from '../../Common/Transition/DialogTransition';
import RelationshipLinkageTab from '../../Common/ModelInventoryAndAssociation/Summary/RelationshipLinkageTab';
import useModelInventory from '../../../hooks/ModelInventory/useModelInventory';

const ShowModelLineageModal = ({
  open,
  handleClose,
  previewItem,
  entityType = 'ModelInventory',
}) => {
  const [entityId, setEntityId] = useState(null);
  const { isEntityAvailable } = useModelInventory();

  const handleClosePreview = useCallback(() => {
    handleClose();
  }, [handleClose]);

  useEffect(() => {
    if (previewItem?.item?.id && open) {
      isEntityAvailable(
        {
          entityType,
          uniqueId: previewItem?.item?.id,
        },
        false
      ).then((res) => {
        if (res?.data?.entity_id) {
          setEntityId(res?.data?.entity_id);
        }
      });
    }
  }, [previewItem?.item?.id, open, entityType]);

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      TransitionComponent={DialogTransition}
    >
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          {previewItem?.title}
        </Box>
      </DialogTitle>

      <IconButton
        color="primary"
        aria-label="Close dialog"
        onClick={handleClosePreview}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container xs={12} mb={2} p={1}>
          <Grid item xs={12}>
            <Box width="100%" height="60vh">
              {open && entityId && (
                <RelationshipLinkageTab
                  entityId={entityId}
                  entityType={entityType}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

ShowModelLineageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  previewItem: PropTypes.shape({
    item: PropTypes.shape({
      id: PropTypes.number,
    }),
    title: PropTypes.string,
  }).isRequired,
  entityType: PropTypes.string,
};

export default ShowModelLineageModal;
